import React from "react";
import { twMerge } from "tailwind-merge";

const OrangeBar = ({ className = "" }) => (
  <div className={twMerge("bg-orangeBg h-5 w-[105px]", className)} />
);

export default OrangeBar;
